import { observer } from 'mobx-react-lite';
import { useId } from 'react';
import styled from '@emotion/styled';
import { SearchInput } from '../../../components/common/search-input/SearchInput';
import { Css, Responsive } from '../../../ui';

interface IProps {
	query: string;
	updateQuery: (newQuery: string) => void;
	inputRef: React.RefObject<HTMLInputElement>;
}

export const SearchInputContainer = observer(
	({ query, updateQuery, inputRef }: IProps) => {
		const labelId = useId();

		return (
			<StyledWrap>
				<ContentSearchInput
					type="text"
					ref={inputRef}
					label="Enter your search"
					labelId={labelId}
					value={query}
					onChange={(e) => updateQuery(e.target.value)}
					onClear={() => updateQuery('')}
					onQuerySubmit={() => updateQuery(query)}
					autoFocus
					dropdownIsOpen={false}
				/>
			</StyledWrap>
		);
	},
);

const StyledWrap = styled.div`
	width: 100%;

	display: flex;
	justify-content: center;
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		flex: 1;
	}
`;

const ContentSearchInput = styled(SearchInput)`
	max-width: ${Css.pxToRem(936)};
`;
